<template>
  <div class="log-item-container">
    <div
      class="log-item d-flex flex-column align-items-center px-3 h-100"
    >
      <p
        class="log-date mb-1"
        :class="stateClass"
      >
        <span
          v-if="log.dashboardUserName != null"
        >
          {{ log.dashboardUserName }}
        </span><br/>
        {{ dateString }}
      </p>
      <p
        class="log-content mb-2"
        :class="stateClass"
      >
        {{ logItemContent }} 
        <template
          v-if="contentExceedsMaxLength"
        >... <a
          class="show-more"
          @click.prevent="showModal"
        >
          meer
        </a>
        </template>
      </p>

      
      <span class="timeline-pointer" />
      <span class="timeline-circle" />
    </div>
    <div class="item-border" />
  </div>
  
  <modal
    v-if="contentExceedsMaxLength"
    ref="modelRef"
  >
    <template #header>
      <h6 class="mb-0">Detail</h6>
    </template>
    {{ content }}
  </modal>
</template>

<script>
import { parseDate } from '@/helpers/parsers';

import Modal from '@/components/UI/Modal/Modal.vue';
import ReportDetailStore from '@/store/pages/Report/report-detail-store';

const maxContentLength = 100;

export default {
  components: {
    Modal,
  },

  props: {
    log: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  computed: {
    dateString() {
      return ReportDetailStore.getters.isLoading
        ? 'Placeholder'
        : parseDate(this.log.dateOfLog);
    },

    logItemContent() {
      return this.contentExceedsMaxLength
        ? this.truncatedContent
        : this.content;
    },

    content() {
      return ReportDetailStore.getters.isLoading
        ? 'Placeholder paragraph #1. Placeholder paragraph #2'
        : this.log.logContent;
    },

    truncatedContent() {
      return this.content.substring(0, maxContentLength);
    },

    contentExceedsMaxLength() {
      return this.content.length > maxContentLength;
    },

    stateClass() {
      return {
        'placeholder': ReportDetailStore.getters.isLoading
      }
    }
  },

  methods: {
    showModal() {
      this.$refs.modelRef.show();
    },
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0; 
  white-space: normal;
}

.log-item-container {
  flex: 0 0 auto;
  height: 100%;
  position: relative;

  .log-date {
    text-align: center;
    font-size: 0.85em;
    font-weight: 500;
  }

  .log-content {
    font-size: 1.1em;
    text-align: center;
    max-width: 250px;
  }

  .line-bottom {
    height: 100%;
    width: 1px;
    margin-inline: 50%;
    transform: translateX(50%);
    background: #888;
    position: relative;
  }

  .timeline-pointer {
    width: 1px;
    flex-grow: 1;
    background:#888;
  }

  .timeline-circle::after {
      content: '';
      display: block;
      width: 9px;
      height: 9px;
      margin-bottom: -5px;
      border-radius: 50%;
      border: 1px solid #888;
      background: #fff;
    }

  .item-border {
    border-bottom: 1px solid #888;

  }

  &:first-child .item-border { 
    width: 50%;
    float: right;
  }

  .show-more {
    color: #888;
    font-size: 0.8em;
    text-decoration: underline;
    cursor: pointer;
    text-underline-offset: 3px;
  }
}
</style>